export default{
  "Video Compressor": "Video Compressor",
  "HitPaw Online Video Compressor": "HitPaw Online Video Compressor",
  "Best video compressor tool to reduce video file size online without losing quality.": "Beste video compressie tool om online video bestandsgrootte te verkleinen zonder kwaliteitsverlies.",
  "Quality": "Kwaliteit",
  "Small Size": "Klein Formaat ({{num}}%)",
  "High Quality": "Hoge Kwaliteit ({{num}}%)",
  "Frame Rate": "Beeldsnelheid",
  "Resolution": "Resolutie",
  "Keep Resolution": "Resolutie Behouden",
  "Format": "Formaat",
  "Compress": "Comprimeer",
  "Compressing": "Comprimeren",
  "Compress New": "Comprimeren Nieuw",
  "xx% reduction in size!": "{{num}}% vermindering in grootte!",
  "Compressed successfully, your file is now xxMB.": "Succesvol gecomprimeerd, uw bestand is nu <p> {{originalSize}}MB</p> <p>{{compressSize}}MB</p>.",
  "Compression Failed": "Compressie mislukt",
};